<template>
  <div class="list-view product-checkout mt-0">

    <!-- Products List -->
    <e-commerce-checkout-step-cart-products />

    <!-- Checkout Options -->
    <div class="checkout-options">
      <b-card>
        <div class="price-details">
          <h6 class="price-title">
            Sepet Detayı
          </h6>
          <ul class="list-unstyled">
            <li class="price-detail">
              <div class="detail-title">
                Kargo Ücreti
              </div>
              <div class="detail-amt discount-amt text-success">
                Ücretsiz
              </div>
            </li>
          </ul>
          <hr>
          <ul class="list-unstyled">
            <li class="price-detail">
              <div class="detail-title detail-total">
                Toplam KDV Dahil
              </div>
              <div class="detail-amt font-weight-bolder">
                {{ Number(totalCount).toLocaleString('tr-TR', {minimumFractionDigits: 2}) }}₺
              </div>
            </li>
          </ul>
          <b-button
            variant="primary"
            block
            @click="$emit('next-step')"
          >
            Sepeti Onayla
          </b-button>
        </div>

      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BButton, BCard,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import ECommerceCheckoutStepCartProducts from './ECommerceCheckoutStepCartProducts.vue'

export default {
  components: {
    // BSV
    BButton,
    BCard,

    // SFC
    ECommerceCheckoutStepCartProducts,
  },
  computed: {
    ...mapGetters({
      basketList: 'eCommerce/getBasketList',
    }),
    totalCount() {
      return this.basketList.reduce((a, b) => a + (b.price || 0), 0)
    },
  },
}
</script>
